import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ComingSoonPage } from '../routes/ComingSoonPage';
import { useProjectStore } from '../project/project-store';
import { RequireProject } from '../project/RequireProject';
import { LeaseListPage } from '../routes/land-data/leases/LeaseListPage';
import { ContractListPage } from '../routes/land-data/contracts/ContractListPage';
import { WellListPage } from '../routes/land-data/wells/WellListPage';
import { ObligationListPage } from '../routes/land-data/obligations/ObligationListPage';

/**
 * Land Data shell, namespaced under `/a/land-data/*`. Lease, Contract, Wells,
 * and Obligations (project-scoped, gated by RequireProject like Running
 * Title's routes) are all live — Obligations is the 4th Land Data vertical
 * slice, so no ComingSoon stubs remain under this app.
 */
export function LandDataShell() {
  // See RunningTitleShell for why this is needed: a deep-link/bookmark/back
  // navigation here can bypass the click handlers that normally call
  // setApp(), leaving the store out of sync with the route.
  useEffect(() => {
    if (useProjectStore.getState().appKey !== 'land_data') {
      useProjectStore.getState().setApp('land_data');
    }
  }, []);

  return (
    <Routes>
      <Route index element={<ComingSoonPage name="Land Data" />} />
      <Route
        path="lease"
        element={
          <RequireProject>
            <LeaseListPage />
          </RequireProject>
        }
      />
      <Route
        path="contracts"
        element={
          <RequireProject>
            <ContractListPage />
          </RequireProject>
        }
      />
      <Route
        path="wells"
        element={
          <RequireProject>
            <WellListPage />
          </RequireProject>
        }
      />
      <Route
        path="obligations"
        element={
          <RequireProject>
            <ObligationListPage />
          </RequireProject>
        }
      />
    </Routes>
  );
}
